import { BACKEND } from "../variables.js";
import axios from "axios";
const GET_TENANTS = BACKEND + "/tenants/getTenantsByHouse";
const GET_TENANT_BY_ID = BACKEND + "/tenants/getTenantsById";
const CREATE_TENANT = BACKEND + "/tenants/add";
const ONBOARD_TENANT = BACKEND + "/tenants/onboard";
const IMPORT_TENANTS_EXCEL = BACKEND + "/tenants/importExcel";
const IMPORT_TENANTS_EXCEL_SAMPLE = BACKEND + "/tenants/importExcel/sample";
const COMMIT_TENANTS_EXCEL_IMPORT = BACKEND + "/tenants/importExcel/commit";
const SAVE_IMPORT_RUN = BACKEND + "/tenants/importRuns/save";
const LIST_IMPORT_RUNS = BACKEND + "/tenants/importRuns/list";
const GET_IMPORT_RUN = BACKEND + "/tenants/importRuns/get";
const UPDATE_TENANT = BACKEND + "/tenants/update";
const SET_CONTRACT_UPDATED = BACKEND + "/tenants/setContractUpdated";
const SET_TENANT_STATUS = BACKEND + "/tenants/setStatus";
const DELETE_TENANT = BACKEND + "/tenants/delete";
const CHECK_TENANT_EMAIL = BACKEND + "/tenants/checkEmail";
const TENANT_LOGIN = BACKEND + "/tenants/login";
const TENANT_LOGOUT = BACKEND + "/tenants/logout";
const FORGOT_TENANT_PASSWORD = BACKEND + "/tenants/forgotPassword";
const GET_TENANT_STATS = BACKEND + "/tenants/stats";
const UPDATE_TENANT_INFO = BACKEND + "/tenants/updateMyAccount";
const UPDATE_TENANT_PASSWORD = BACKEND + "/tenants/updateMyPassword";
const RESET_TENANT_PASSWORD = BACKEND + "/tenants/resetTenantPassword";
const TENANT_PROFILE_PDF = BACKEND + "/tenants/profilePdf";
const GET_TENANT_EVALUATIONS = BACKEND + "/tenantEvaluations/getByTenant";
const GET_MY_LATEST_EVALUATION = BACKEND + "/tenantEvaluations/getMyLatestEvaluation";
const ADD_TENANT_EVALUATION = BACKEND + "/tenantEvaluations/add";
const ADD_TENANT_EVALUATION_DOCUMENT = BACKEND + "/tenantEvaluations/addDocument";
const DELETE_TENANT_EVALUATION = BACKEND + "/tenantEvaluations/delete";

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    ["GET_TENANTS"](state, payload) {
      return axios({
        method: "POST",
        url: GET_TENANTS,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["GET_TENANT_BY_ID"](state, payload) {
      return axios({
        method: "POST",
        url: GET_TENANT_BY_ID,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["GET_TENANT_PROFILE_PDF"](state, payload) {
      return axios({
        method: "POST",
        url: TENANT_PROFILE_PDF,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
        responseType: "blob",
      });
    },
    ["CHECK_TENANT_EMAIL"](state, payload) {
      return axios({
        method: "POST",
        url: CHECK_TENANT_EMAIL,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["CREATE_TENANT"](state, payload) {
      return axios({
        method: "POST",
        url: CREATE_TENANT,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    // Atomic registration: tenant + subscription + lines + month-grouped invoices in one request.
    ["ONBOARD_TENANT"](state, payload) {
      return axios({
        method: "POST",
        url: ONBOARD_TENANT,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    /**
     * Upload an Excel file of tenants + subscriptions to the bulk-import endpoint.
     * payload.formData is a FormData instance with: file (Blob), house_id, dry_run.
     */
    ["IMPORT_TENANTS_EXCEL"](state, payload) {
      return axios({
        method: "POST",
        url: IMPORT_TENANTS_EXCEL,
        data: payload.formData,
        headers: {
          Authorization: payload.token,
          "Content-Type": "multipart/form-data",
        },
      });
    },
    /**
     * Phase 2: commit the (admin-edited) preview rows. JSON body, no file.
     * payload.data: { house_id, rows: [...] }
     */
    ["DOWNLOAD_TENANTS_EXCEL_SAMPLE"](state, payload) {
      return axios({
        method: "GET",
        url: IMPORT_TENANTS_EXCEL_SAMPLE,
        params: payload.data,
        headers: { Authorization: payload.token },
        responseType: "blob",
      });
    },
    ["COMMIT_TENANTS_EXCEL_IMPORT"](state, payload) {
      return axios({
        method: "POST",
        url: COMMIT_TENANTS_EXCEL_IMPORT,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["SAVE_IMPORT_RUN"](state, payload) {
      return axios({
        method: "POST",
        url: SAVE_IMPORT_RUN,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    ["LIST_IMPORT_RUNS"](state, payload) {
      return axios({
        method: "POST",
        url: LIST_IMPORT_RUNS,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    ["GET_IMPORT_RUN"](state, payload) {
      return axios({
        method: "POST",
        url: GET_IMPORT_RUN,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    ["UPDATE_TENANT"](state, payload) {
      return axios({
        method: "POST",
        url: UPDATE_TENANT,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["SET_CONTRACT_UPDATED"](state, payload) {
      return axios({
        method: "POST",
        url: SET_CONTRACT_UPDATED,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["SET_TENANT_STATUS"](state, payload) {
      return axios({
        method: "POST",
        url: SET_TENANT_STATUS,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["DELETE_TENANT"](state, payload) {
      return axios({
        method: "POST",
        url: DELETE_TENANT,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["TENANT_LOGIN"](state, payload) {
      return axios({
        method: "POST",
        url: TENANT_LOGIN,
        data: payload.data,
      });
    },
    ["TENANT_LOGOUT"](state, payload) {
      return axios({
        method: "POST",
        url: TENANT_LOGOUT,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["FORGOT_TENANT_PASSWORD"](state, payload) {
      return axios({
        method: "POST",
        url: FORGOT_TENANT_PASSWORD,
        data: payload.data,
      });
    },
    ["GET_TENANT_STATS"](state, payload) {
      return axios({
        method: "POST",
        url: GET_TENANT_STATS,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["UPDATE_TENANT_INFO"](state, payload) {
      return axios({
        method: "POST",
        url: UPDATE_TENANT_INFO,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["UPDATE_TENANT_PASSWORD"](state, payload) {
      return axios({
        method: "POST",
        url: UPDATE_TENANT_PASSWORD,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["RESET_TENANT_PASSWORD"](state, payload) {
      return axios({
        method: "POST",
        url: RESET_TENANT_PASSWORD,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["GET_TENANT_EVALUATIONS"](state, payload) {
      return axios({
        method: "POST",
        url: GET_TENANT_EVALUATIONS,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["GET_MY_LATEST_EVALUATION"](state, payload) {
      return axios({
        method: "POST",
        url: GET_MY_LATEST_EVALUATION,
        data: payload.data || {},
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["ADD_TENANT_EVALUATION"](state, payload) {
      return axios({
        method: "POST",
        url: ADD_TENANT_EVALUATION,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["ADD_TENANT_EVALUATION_DOCUMENT"](state, payload) {
      return axios({
        method: "POST",
        url: ADD_TENANT_EVALUATION_DOCUMENT,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
    ["DELETE_TENANT_EVALUATION"](state, payload) {
      return axios({
        method: "POST",
        url: DELETE_TENANT_EVALUATION,
        data: payload.data,
        headers: {
          Authorization: payload.token,
        },
      });
    },
  },
};
